/* webpackMode: "lazy-once" */
/* webpackChunkName: "process" */
import * as processShim from 'process/browser';
// =============================================================================
// IMPORTANT MONA OVERRIDE: PROCESS FOR BROWSER
// =============================================================================

function isNotEmpty<T extends any>(value: T): value is NonNullable<T> {
    return value !== undefined || value !== null || value !== 'undefined' || value !== 'null';
}

try {
    process?.platform;
} catch (error) {
    globalThis.process = processShim;
}
